import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchStoresNearby } from "../services/api";

export const loadNearbyStores = createAsyncThunk(
    "storeNearby/load",
    async ({ lat, lon, category = "", reset = false }, { getState, rejectWithValue }) => {
        try {
            const offset = reset ? 0 : getState().storeNearby.nextOffset ?? 0;
            const res = await fetchStoresNearby({ mode: "nearby", lat, lon, category, offset });
            return {
                items: res?.data?.items ?? [],
                nextOffset: res?.data?.nextOffset ?? null,
                reset,
            };
        } catch (err) {
            return rejectWithValue(err?.message || "Couldn't load nearby stores.");
        }
    }
);

const storeNearbySlice = createSlice({
    name: "storeNearby",
    initialState: { items: [], nextOffset: null, loading: false, loadingMore: false, error: null },
    reducers: {
        resetStoreNearby: () => ({
            items: [], nextOffset: null, loading: false, loadingMore: false, error: null,
        }),
    },
    extraReducers: (builder) => {
        builder
            .addCase(loadNearbyStores.pending, (state, action) => {
                if (action.meta.arg.reset) state.loading = true;
                else state.loadingMore = true;
                state.error = null;
            })
            .addCase(loadNearbyStores.fulfilled, (state, action) => {
                state.loading = false;
                state.loadingMore = false;
                state.items = action.payload.reset ? action.payload.items : [...state.items, ...action.payload.items];
                state.nextOffset = action.payload.nextOffset;
            })
            .addCase(loadNearbyStores.rejected, (state, action) => {
                state.loading = false;
                state.loadingMore = false;
                state.error = action.payload;
            });
    },
});

export const { resetStoreNearby } = storeNearbySlice.actions;
export default storeNearbySlice.reducer;